// Recent searches — a small, honest "recency" feature backed by the user's own
// past queries on this device (localStorage), not a server endpoint. There is
// no search-history API in services/api.ts, so this is real (not fabricated)
// data scoped to what it actually is: this browser's recent queries.
import { Clock } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { getRecentSearches } from '../../lib/recentSearches'

interface RecentSearchesProps {
  onSelect: (query: string) => void
}

export default function RecentSearches({ onSelect }: RecentSearchesProps) {
  const { user } = useAuth()
  const recent = getRecentSearches(user?.id)
  if (recent.length === 0) return null

  return (
    <div className="mb-6" data-testid="recent-searches">
      <p className="text-xs font-medium text-gray-500 mb-2 flex items-center gap-1">
        <Clock size={12} /> Recent searches
      </p>
      <div className="flex flex-wrap gap-2">
        {recent.map((q) => (
          <button
            key={q}
            onClick={() => onSelect(q)}
            className="px-3 py-1.5 text-xs bg-white border border-sky-200 rounded-full text-gray-700 hover:border-iflow-300 hover:text-iflow-700 flex items-center gap-1.5 transition-colors"
          >
            <Clock size={11} className="text-gray-500" /> {q}
          </button>
        ))}
      </div>
    </div>
  )
}
